import {ApiResourceFactory} from '../api.resource.factory'
import {ResponseListModel, GridRequestModel, GridModel, SimpleValueModel} from '../api.models'
import {CommonHelper} from '../../../helpers/common-helper'

export interface IKPIService {
    getAggregationPeriods(): ng.IPromise<ResponseListModel<string>>

    getLocations(req: GridRequestModel, state?: any): ng.IPromise<GridModel>

    getMeters(req: GridRequestModel, state?: any): ng.IPromise<GridModel>

    getDates(state?: any): ng.IPromise<SimpleValueModel<any>>
}

export class KPIService implements IKPIService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getAggregationPeriods() {
        return this.apiResource.kpi['getAggregationPeriods']().$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON();
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status)
        )
    }

    getLocations(req: GridRequestModel, state: any = {}) {
        return this.apiResource.kpi['getKpiLocations'](req).$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON();
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getMeters(req: GridRequestModel, state: any = {}) {
        return this.apiResource.kpi['getKpiMeters'](req).$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON();
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getDates(state: any = {}) {
        return this.apiResource.kpi['getKpiDates']().$promise.then(result => {
            return (<any>result).toJSON();
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

}
